var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHotelBedsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2276_159781",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2276_159781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9624 13.0973V17.5081H15.2381V13.5514C15.2381 12.4486 14.7841 11.9946 14.0057 11.9946C13.1624 11.9946 12.4489 12.5135 12.4489 13.8108V17.5081H9.72461V7H12.4489V10.5676C13.0327 9.98378 13.876 9.72432 14.7841 9.72432C16.6003 9.72432 17.9624 10.7622 17.9624 13.0973Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4489 14.8487H9.72461V17.573H12.4489V14.8487Z",
    fill: "#B92454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72432 12.1243H7V14.8487H9.72432V12.1243Z",
    fill: "#9FCFCA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHotelBedsCircle);
export default __webpack_public_path__ + "static/media/IcoHotelBedsCircle.f827d01dadd6ff50ca129b8d35dce29b.svg";
export { ForwardRef as ReactComponent };